import {FC} from 'react'
import {Routes, Route, BrowserRouter, Navigate, Link} from 'react-router-dom'
import {PrivateRoutes} from './PrivateRoutes'
import {ErrorsPage} from '../pages/errors/ErrorsPage'
import {Logout, AuthPage, useAuth} from '../core/auth'
import {App} from '../App'
import {ForgotPassword} from '../components/auth/ForgotPassword'

const {PUBLIC_URL} = process.env

const AppRoutes: FC = () => {
  const {currentUser} = useAuth()
  return (
    <BrowserRouter basename={PUBLIC_URL}>
      <Routes>
        <Route element={<App />}>
          <Route path='error/*' element={<ErrorsPage />} />
          <Route path='logout' element={<Logout />} />
          {currentUser ? (
            <>
              {currentUser.update_password && currentUser.update_password === 1 ? (
                <Route path='/*' element={<ForgotPassword />} />
              ) : (
                <>
                  <Route path='/*' element={<PrivateRoutes />} />
                  <Route index element={<Navigate to='/dashboard' />} />
                </>
              )}
            </>
          ) : (
            <>
              <Route path='auth/*' element={<AuthPage />} />
              <Route path='*' element={<Navigate to='/auth' />} />
            </>
          )}
        </Route>
      </Routes>
    </BrowserRouter>
  )
}

export {AppRoutes}
